export const purchaseInvoice = {
	titlePage: "Notas fiscais de compra",
	description:
		"A nota fiscal de compra é o documento referente à movimentação do estoque das mercadorias que a sua empresa está recebendo. Aqui será possível importar suas notas, ver seu histórico de importação, além do detalhamento por produto das	mesmas.",
	tabs: {
		historyNf: "Histórico de importação",
		detailingByProduct: "Detalhamento por produto",
		importationInvoices: "Importação de notas fiscais",
	},
	importHistory: {
		columns: {
			nf: "NF",
			supplier: "Fornecedor",
			emission: "Data Emissão",
			createdAt: "Data de Importação",
			totalValue: "Valor",
			status: "Status",
			statusMessage: {
				processed: "Processada",
				Unprocessed: "Não Processada",
				Deprocessed: "Desprocessada",
			},
		},
		fields: {
			searchNf: "Número da nota",
			searchSupplier: "Nome do fornecedor",
			searchDateEmissionRange: {
				start: "Início Data Emissão",
				end: "Final Data Emissão",
			},
			searchDateImportRange: {
				start: "Início Data Importação",
				end: "Final Data Importação",
			},
		},
		table: {
			emptyText: "Não existem notas a serem mostradas",
			reportPrint: "Histórico de importação",
		},
		excelExportHistoryImport: {
			filename: "historico_importacao",
			title: "Histórico de importação",
		},
		modalDelete: {
			title: "Excluir nota",
			cancelText: "Cancelar",
			okText: "Excluir",
			message1: "A exclusão da NF",
			message2: "é permanente. Deseja continuar mesmo assim?",
		},
		modalUnprocess: {
			title: "Desprocessar nota",
			cancelText: "Cancelar",
			closeText: "Fechar",
			okText: "Desprocessar nota",
			message1: "Ao desprocessar uma nota você gera as seguintes ações:",
			message2: "Os produtos adicionados no estoque serão removidos;",
			message3: "A lançamento da nota será removido do contas a pagar.",
			message4: "Deseja desprocessar a nota mesmo assim?",
		},
		actionTable: {
			delete: "Excluir",
			unprocess: "Desprocessar",
			download: "Download",
		},
	},
	detailingProduct: {
		unassociatedProduct: "Produto não associado",
		infoBasCalcUnitCost:
			"A base de cálculo do custo unitário é: Valor total - Desconto + IPI + ICMS + Frete + Seguro + Outras despesas / Quantidade",
		columns: {
			nf: "NF",
			supplierName: "Fornecedor",
			emission: "Data Emissão",
			unitQuantity: "QTD (NF)",
			commercialUnit: "UN (NF)",
			unitValue: "Custo Unitário (NF)",
			totalValue: "Custo total (NF)",
			inputDate: "Data entrada estoque",
			invoiceEntry: "Produto Importado",
			associateProduct: "Produto associado (ZIG)",
			unitQuantityZig: "QTD (ZIG)",
			commercialUnitZig: "UN (ZIG)",
			unitValueZig: "Custo unitário (ZIG)",
		},
		excelExportDetailingProduct: {
			fileName: "detailing_product",
			title: "Detalhamento por produto",
		},
		fields: {
			searchNf: "Insira o número da nota",
			searchSupplier: "Insira o nome do emitente",
			searchDateRange: {
				processedAtDate: {
					start: "Início data entrada",
					end: "Final data entrada",
				},
				emissionDate: {
					start: "Início data emissão",
					end: "Final data emissão",
				},
			},
			isAssociatedProduct: "Apenas produtos não associados",
		},
		emptyText: "Não existem produtos não associados neste perfil fiscal",
	},
	importationInvoices: {
		title: "Selecione um perfil fiscal para começar",
		emptyText: "Nenhuma Nota Fiscal de Compra",
		fiscalProfiles: "Perfil fiscal",
		issueDate: "Filtrar por data",
		issuer: "Filtrar por nome do fornecedor",
		status: "Filtrar por status",
		btnUpdate: "Atualizar",
		xmlUnavailableInfo:
			"Para disponibilizar os arquivos XML com status indisponível é necessário realizar a manifestação da nota. Em caso de dúvidas na manifestação consulte o seu contador.",
		modalInfoImport: {
			notAllowed: {
				title: "Não autorizada",
			},
			xmlUnavailable: {
				title: "XML indisponível",
				reason:
					"O código XML desta nota fiscal ainda não está disponível. Aguarde para fazer a importação da nota fiscal.",
			},
		},
		fiscalProfilesOptions: {
			disabledMessage:
				"Perfil fiscal não está habilitado para buscar notas fiscais, edite o perfil antes de prosseguir",
			notEnabled: "(NÃO HABILITADO)",
		},
		columns: {
			issuerName: "Fornecedor",
			issuerCnpj: "CNPJ ou CPF",
			issueDate: "Data Emissão",
			totalValue: "Valor da Nota",
			status: {
				title: "Status",
				imported: "Importada",
				authorized: "Autorizada",
				notAllowed: "Não autorizada",
				xmlUnavailable: "XML indisponível",
			},
		},
	},
};
